export default "__VITE_ASSET__CFWKQ6xL__"